import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAirplane: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="airplane, flight"><path d="M16.4812 3.92157L13.5417 6.86111L4.80556 3.77778L2.75 5.83333L9.43056 10.9722L7.375 13.0278H5.31944L2.75 15.5972L6.86111 17.1389L8.40278 21.25L10.9722 18.6806V16.625L13.0278 14.5694L18.1667 21.25L20.2222 19.1944L17.1389 10.4583L20.0784 7.5188C20.8286 6.76865 21.25 5.75123 21.25 4.69037V2.75H19.3096C18.2488 2.75 17.2314 3.17143 16.4812 3.92157Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconAirplane;
